import { WhatsApp } from '@mui/icons-material';
import { WhatsAppWrapper, WhatsAppLink } from './styles';

const WhatsAppButton = () => {
  const phoneNumber = '972548827511'; // מספר הטלפון שלך
  const message = 'היי, אשמח לקבל מידע על ייעוץ משכנתאות';

  return (
    <WhatsAppWrapper>
      <WhatsAppLink 
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <WhatsApp />
      </WhatsAppLink>
    </WhatsAppWrapper>
  );
};

export default WhatsAppButton; 